/* eslint-disable @typescript-eslint/no-explicit-any */
import { Delete, Get, Patch, Post } from "./apiHelper";
import { ILeaveBalance } from "../interfaces/LeaveBalanceInterface";
import { ApiResponse } from "../interfaces/Api";

const leaveBalanceRoot = "/api/leaveBalances";

// get leave balances
export async function getLeaveBalances({
  resourceCentreId,
  serviceProviderIds = [],
  employeeIds = []
}: {
  resourceCentreId: number;
  serviceProviderIds?: Array<number>;
  employeeIds?: Array<number>;
}): Promise<ApiResponse<Array<ILeaveBalance>>> {
  const searchParams = new URLSearchParams();

  searchParams.append("resourceCentreId", resourceCentreId.toString());

  if (serviceProviderIds?.length) {
    const spIds = serviceProviderIds.join(",");
    searchParams.append("serviceProviderIds", spIds);
  }

  if (employeeIds?.length) {
    const eIds = employeeIds.join(",");
    searchParams.append("employeeIds", eIds);
  }

  const response = await Get(`${leaveBalanceRoot}?${searchParams.toString()}`, true);
  return response.data as ApiResponse<Array<ILeaveBalance>>;
}

// post leave balance
export async function postLeaveBalance(
  data: Partial<ILeaveBalance>
): Promise<ApiResponse<ILeaveBalance>> {
  const response = await Post(`${leaveBalanceRoot}`, data as any, true);
  return response.data as ApiResponse<ILeaveBalance>;
}

// patch leave balance
export async function patchLeaveBalance({
  id,
  data
}: {
  id: number | string;
  data: Partial<ILeaveBalance>;
}): Promise<ApiResponse<ILeaveBalance>> {
  const response = await Patch(`${leaveBalanceRoot}/${id}`, data as any, true);
  return response.data as ApiResponse<ILeaveBalance>;
}

// delete leave balance
export async function deleteLeaveBalance(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${leaveBalanceRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
